export default __webpack_public_path__ + "static/media/Supremacy - Terms and Conditions v2.7f9c610a.pdf";